import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { DocsLayout } from "@/features/docs/components/DocsLayout";
import { DocsLoginPage } from "@/features/docs/pages/DocsLoginPage";
import { DocsHomePage } from "@/features/docs/pages/DocsHomePage";
import { DocsPageView } from "@/features/docs/pages/DocsPageView";
import { MagicLinkAdminPage } from "@/features/docs-admin/MagicLinkAdminPage";
import { DocsInternalLibrary } from "@/features/docs/pages/DocsInternalLibrary";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root to docs */}
        <Route path="/" element={<Navigate to="/docs" replace />} />

        {/* Docs portal — login is full-screen (no sidebar) */}
        <Route path="/docs/login" element={<DocsLoginPage />} />

        {/* Docs admin — internal magic-link generator (requires docs.admin
            role via Entra OIDC session; not wrapped in DocsAuthProvider) */}
        <Route path="/docs/admin/magic-links" element={<MagicLinkAdminPage />} />

        {/* Docs portal — authenticated pages use DocsLayout (sidebar + header) */}
        <Route path="/docs" element={<DocsLayout />}>
          <Route index element={<DocsHomePage />} />
          <Route path="internal" element={<DocsInternalLibrary />} />
          <Route path="page/:id" element={<DocsPageView />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
